import { downloadCommiteeCsv } from '../download.utils';

export function useExportEmployees() {
  return downloadCommiteeCsv({
    url: '/commitee/:commiteeId/employees/export',
    filename: 'employees.csv',
  });
}

export function useExportEmployeeBeneficiaries(id: number) {
  return downloadCommiteeCsv({
    url: `/commitee/:commiteeId/employees/${id}/export/beneficiaries`,
    filename: 'employee-beneficiaries.csv',
  });
}

export function useExportEmployeeActionsHistory(id: number) {
  return downloadCommiteeCsv({
    url: `/commitee/:commiteeId/employees/${id}/export/actions-history`,
    filename: 'employee-actions-history.csv',
  });
}

export function useExportEmployeeActivitiesHistory(id: number) {
  return downloadCommiteeCsv({
    url: `/commitee/:commiteeId/employees/${id}/export/activities-history`,
    filename: 'employee-activities-history.csv',
  });
}

export function useExportEmployeeCommunicationsHistory(id: number) {
  return downloadCommiteeCsv({
    url: `/commitee/:commiteeId/employees/${id}/export/communications-history`,
    filename: 'employee-communications-history.csv',
  });
}

export function useExportEmployeeFinancialExchanges(id: number) {
  return downloadCommiteeCsv({
    url: `/commitee/:commiteeId/employees/${id}/export/financial-exchanges`,
    filename: 'employee-financial-exchanges.csv',
  });
}
